import AxiosApi from '@/config/axios'

const TokenService = {};

TokenService.validateToken = (id, token) => {
    return AxiosApi({
        url: '/validate-token',
        method: 'post',
        data:{
            id: id,
            token: token
        }
    })
}

export default TokenService;